import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import useUIHelperContext from '../../hooks/useUIHelperContext';
import UIHelperPopup from './UIHelperPopup';
import UIHelperBackdrop from './UIHelperBackdrop';
import styles from './styles.module.scss';

export default function UIHelperPortal() {
  const { activeHelper, hideAllHelpers } = useUIHelperContext();
  const overlayRef = useRef();

  // Handle escape key and clicks
  useEffect(() => {
    if (!activeHelper) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        hideAllHelpers();
      }
    };

    const handleClick = () => {
      hideAllHelpers();
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('click', handleClick, true); // Use capture phase

    // eslint-disable-next-line consistent-return
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('click', handleClick, true);
    };
  }, [activeHelper, hideAllHelpers]);

  if (!activeHelper) {
    return null;
  }

  return (
    <>
      {createPortal(
        <UIHelperBackdrop
          helper={activeHelper}
          onClickOutside={hideAllHelpers}
        />,
        document.body
      )}
      {createPortal(
        <div ref={overlayRef} className={styles.uiHelperOverlay}>
          <UIHelperPopup helper={activeHelper} />
        </div>,
        document.body
      )}
    </>
  );
}
